// extracted by mini-css-extract-plugin
export default {"container":"bA-z","heading":"cA-z","text":"dA-z","info":"eA-z","link":"fA-z","fullMaxWidth":"gA-z"};